import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

import { budget_options } from '@Config/options'

export let form =
{
	model: 'EnterpriseCommittee'.toLowerCase(),
	name: 'EnterpriseCommittee'.toLowerCase(),

	form_title: 'Comité d\'Entreprise',

	fields:
	{
		company:
		{
			label: 'Nom de la Société'
		},

		'address[line_1]':
		{
			label: 'Adresse'
		},

		'address[line_2]':
		{
			label: 'Complément d\'adresse'
		},

		'address[zip_code]':
		{
			label: 'Code postal'
		},

		'address[city]':
		{
			label: 'Ville'
		},

		phone:
		{
			type: 'tel',
			label: 'Téléphone du CE'
		},

		abondement_code:
		{
			type: 'text',
			label: 'Code abondement'
		},

		email:
		{
			type: 'email',
			label: 'Email du CE'
		},

		opening_time:
		{
			type: 'editor',
			label: 'Horaires d\'ouverture du CE',
			images: false
		},

		description:
		{
			type: 'editor',
			label: 'Présentation'
		},

		logo:
		{
			type: 'image',
			multiple: false,
			label: 'Logo'
		},

		'pdfs':
		{
			type: 'pdf',
			multiple: true,
			label: 'PDFs de présentation'
		},

		'disabled':
		{
			type: 'checkbox',
			label: 'Désactivé'
		},

		admin_users_only:
		{
			type: 'checkbox',
			label: 'Limiter les admins CSE à la gestion de leurs membres.'
		},

		budget_range:
		{
			label: 'Base tarifaire CSE de + 50 salariés (ETP)',
			type: 'select',
			options: budget_options
		},

		renewal_entry_cost:
		{
			label: 'Tarif droit d\'entrée',
			type: 'text',

			show: function (form_data)
			{
				return form_data['enterprisecommittee[budget_range]'] === 'none';
			}
		},

		renewal_unit_cost:
		{
			label: 'Tarif par actif',
			type: 'text',

			show: function (form_data)
			{
				return form_data['enterprisecommittee[budget_range]'] === 'none';
			}
		},

		renewal_partner_access_cost:
		{
			label: 'Accès module partenaire',
			type: 'text'
		},

		renewal_disabled:
		{
			label: 'Renouvellement - non',
			type: 'checkbox'
		},

		exchange_documents:
		{
			label: 'PDF/Image',
			type: 'image',
			multiple: true
		},

		'config[payment_CC]':
		{
			label: 'Paiement par carte de crédit',
			type: 'checkbox'
		},

		'config[payment_check]':
		{
			label: 'Paiement par chèque',
			type: 'checkbox'
		},

		'config[payment_bank_transfert]':
		{
			label: 'Paiement par virement',
			type: 'checkbox'
		},

		'config[shipping_synergies]':
		{
			label: 'Livraison chez Synergies',
			type: 'checkbox'
		},

		'config[shipping_home]':
		{
			label: 'Livraison à domicile',
			type: 'checkbox'
		},

		'config[shipping_home_price]':
		{
			label: 'Frais de livraison à domicile',
			type: 'number',
			show: function (form_data)
			{
				return ['true', true].includes(
					form_data['enterprisecommittee[config][shipping_home]']);
			}
		},

		'config[shipping_EC]':
		{
			label: 'Livraison au CE',
			type: 'checkbox'
		},

		'config[shipping_EC_price]':
		{
			label: 'Frais de livraison en CE',
			type: 'number',
			show: function (form_data)
			{
				return ['true', true].includes(
					form_data['enterprisecommittee[config][shipping_EC]']);
			}
		},

		'config[can_members_pay]':
		{
			type: 'checkbox',
			label: 'Les salariés peuvent payer'
		},

		'config[can_order_as_EC]':
		{
			type: 'checkbox',
			label: 'Les élus peuvent payer en tant que CE'
		},

		'config[can_use_abondement]':
		{
			type: 'checkbox',
			label: 'Activer l\'abondement'
		},

		'config[can_change_adr]':
		{
			type: 'checkbox',
			label: 'Mise à jour des coordonnées du CE'
		},

		'config[can_access_partners]':
		{
			type: 'checkbox',
			label: 'Espace partenaire'
		},

		'color[main]':
		{
			type: 'colorPicker',
			label: 'Couleur'
		},

		'type':
		{
			label: 'Type',
			type: 'select',
			options:
			[
				{
					value: 'CE'
				},
				{
					value: 'Basique'
				}
			]
		},

		'legal_code':
		{
			label: 'Code comptable'
		},

		'welcome':
		{
			label: 'Texte de bienvenue',
			type: 'editor'
		},

		'sorewards_entity_id':
		{
			label: 'Sorewards - Identifiant de CSE/entité',
			type: 'text'
		}
	},

	collapses:
	[
		{
			type: 'collapse',
			title: 'Relation avec le CE',
			elements:
			[
				'budget_range',
				'exchange_documents',
				'renewal_partner_access_cost',
				'renewal_unit_cost',
				'renewal_entry_cost',
				'renewal_disabled'
			]
		},
		{
			type: 'collapse',
			title: 'Général',
			elements:
			[
				'company',
				'code',
				'description',
				'pdfs',
				'type',
				'legal_code',
				'abondement_code',
				'sorewards_entity_id',
				'welcome',
				'disabled'
			]
		},

		{
			title: 'Coordonnées',
			open: true,
			elements:
			[
				'address[line_1]',
				'address[line_2]',
				'address[zip_code]',
				'address[city]',
				'phone',
				'email',
				'opening_time',
			]
		},

		{
			type: 'collapse',
			title: 'Design',
			elements:
			[
				'logo',
				'color[main]'
			]
		},

		{
			type: 'collapse',
			title: 'Paiement',
			grid_class: 'o-grid-4',
			elements:
			[
				'config[payment_CC]',
				'config[payment_check]',
				'config[payment_bank_transfert]'
			]
		},

		{
			type: 'collapse',
			title: 'Livraison',
			grid_class: 'o-grid-4',
			elements:
			[
				'config[shipping_home]',
				'config[shipping_EC]',
				'config[shipping_synergies]',
				'config[shipping_home_price]',
				'config[shipping_EC_price]'
			]
		},

		{
			type: 'collapse',
			title: 'Droits des utilisateurs',
			grid_class: 'o-grid-4',
			elements:
			[
				'admin_users_only',
				'config[can_members_pay]',
				'config[can_order_as_EC]',
				'config[can_use_abondement]',
				'config[can_change_adr]',
				'config[can_access_partners]'
			]
		}
	],

	create_label: 'Créer ce Comité d\'Entreprise',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce Comité d'Entreprise&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['enterprisecommittee[company]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		let content =
		(
			<div className="c-message__content">
				Le nouveau CE <strong> { model.company } </strong> a été créé.
				{ ' ' }
				<Link className="c-link c-link--highlighted c-link--green"
					href={ '/gestion-des-CE/les-CE/' + model.id }>
					Voir la page du CE
				</Link>
			</div>
		);

		if (model._contacts instanceof Array && model._contacts.length)
		{
			let emails = model._contacts.map(function (data, index)
			{
				let text = '';
				if (index > 0) text = ', ';

				text += data.email;

				let output = <span key={ index }>{ text }</span>;

				return output;
			});

			content =
			(
				<div className="c-message__content">
					Le nouveau CE <strong> { model.company } </strong> a été créé.
					<br />
					Un email de confirmation à été envoyé sur les adresses&nbsp;:
					{ ' ' }
					{ emails }
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-des-CE/les-CE/' + model.id }>
						Voir la page du CE
					</Link>
				</div>
			);
		}

		var output =
		(
			<div className="c-message c-message--green">
				{ content }
			</div>
		);

		return output;
	},

	sort: function (data)
	{
		return data.sort(function (a, b)
		{
			let a_name = a.company.toLowerCase().trim();
			let b_name = b.company.toLowerCase().trim();

			return a_name.localeCompare(b_name);
		});
	}
};

export let list =
{
	model         : 'EnterpriseCommittee'.toLowerCase(),
	title         : 'Liste des Comités d\'Entreprises',
	link          : '/gestion-des-CE/les-CE',
	creation_link : '/gestion-des-CE/nouveau-CE',
	creation_label: 'Nouveau CE',
	header_map:
	{
		'Logo'            : 'logo.url',
		'Entreprise'      : 'company',
		'E-mail'          : 'email',
		'Ville'           : 'address.city',
		'Renouvellement'  : '__renewal',
		'Docs de relation': '_has_documents',
		'Désactivé'       : 'disabled'
	},
	image_fields: ['Logo'],
	row_link_base: '/gestion-des-CE/les-CE/',
	searched_prop: 'company',
	sortable_columns: ['company', 'email', 'address.city', 'disabled']
};

let config = mergeDeep({ }, form);

config = mergeDeep(config, list);

export default config